import axios from "axios";
import config from "../../config";
import {
  CreateFilterOptionRequest,
  CreateFilterTypeRequest,
  FilterClientVisibility,
  FilterOptionDetail,
  FilterShapeDetail,
  FilterTypeDetail,
  UpdateFilterOptionRequest,
  UpdateFilterTypeRequest,
} from "./types";

const apiUrl = config.api;

export const listFilterTypes = async (): Promise<FilterTypeDetail[]> => {
  const response = await axios.get<FilterTypeDetail[]>(
    `${apiUrl}/scoring/mda/filters/types`,
  );

  return response.data;
};

export const getFilterType = async (id: number): Promise<FilterTypeDetail> => {
  const response = await axios.get<FilterTypeDetail>(
    `${apiUrl}/scoring/mda/filters/types/${id}`,
  );

  return response.data;
};

export const createFilterType = async (
  body: CreateFilterTypeRequest,
): Promise<void> => {
  await axios.post(`${apiUrl}/scoring/mda/filters/types`, body);
};

export const updateFilterType = async (
  body: UpdateFilterTypeRequest,
): Promise<void> => {
  await axios.put(`${apiUrl}/scoring/mda/filters/types`, body);
};

export const deleteFilterType = async (id: number): Promise<void> => {
  await axios.delete(`${apiUrl}/scoring/mda/filters/types/${id}`);
};

export const setFilterTypeEnabled = async (
  id: number,
  isEnabled: boolean,
): Promise<void> => {
  await axios.patch(
    `${apiUrl}/scoring/mda/filters/types/${id}/enabled/${isEnabled}`,
  );
};

export const listFilterOptionsByType = async (
  filterTypeId: number,
): Promise<FilterOptionDetail[]> => {
  const response = await axios.get<FilterOptionDetail[]>(
    `${apiUrl}/scoring/mda/filters/types/${filterTypeId}/options`,
  );

  return response.data;
};

export const listFilterOptions = async (): Promise<FilterOptionDetail[]> => {
  const response = await axios.get<FilterOptionDetail[]>(
    `${apiUrl}/scoring/mda/filters/options`,
  );

  return response.data;
};

export const listShapes = async (): Promise<FilterShapeDetail[]> => {
  const response = await axios.get<FilterShapeDetail[]>(
    `${apiUrl}/scoring/mda/filters/shapes`,
  );

  return response.data;
};

export const createFilterOption = async (
  body: CreateFilterOptionRequest,
): Promise<void> => {
  await axios.post(`${apiUrl}/scoring/mda/filters/options`, body);
};

export const updateFilterOption = async (
  body: UpdateFilterOptionRequest,
): Promise<void> => {
  await axios.put(`${apiUrl}/scoring/mda/filters/options`, body);
};

export const deleteFilterOption = async (id: number): Promise<void> => {
  await axios.delete(`${apiUrl}/scoring/mda/filters/options/${id}`);
};

export const getClientOverrides = async (
  clientId: number,
): Promise<FilterClientVisibility[]> => {
  const response = await axios.get<FilterClientVisibility[]>(
    `${apiUrl}/scoring/mda/filters/clients/${clientId}/overrides/`,
  );

  return response.data;
};

export const enableFilterForClient = async (
  filterTypeId: number,
  clientId: number,
): Promise<void> => {
  await axios.post(
    `${apiUrl}/scoring/mda/filters/${filterTypeId}/clients/${clientId}/enable`,
  );
};

export const disableFilterForClient = async (
  filterTypeId: number,
  clientId: number,
): Promise<void> => {
  await axios.post(
    `${apiUrl}/scoring/mda/filters/${filterTypeId}/clients/${clientId}/disable`,
  );
};

export const resetClientToDefault = async (
  filterTypeId: number,
  clientId: number,
): Promise<void> => {
  await axios.post(
    `${apiUrl}/scoring/mda/filters/${filterTypeId}/clients/${clientId}/reset`,
  );
};
